const PREFIX = 'PROFILE'

export const PROFILE_LOADING_STATUS = `${PREFIX}_LOADING_STATUS`
export const PROFILE_NOTES_GET = `${PREFIX}_NOTES_GET`
export const PROFILE_NOTES_UPDATE = `${PREFIX}_NOTES_UPDATE`
export const PROFILE_BOOKMARKS_GET = `${PREFIX}_BOOKMARKS_GET`
export const PROFILE_EDITABLE_NOTE_UPDATE = `${PREFIX}_EDITABLE_NOTE_UPDATE`
export const PROFILE_NOTES_CLEAR = `${PREFIX}_NOTES_CLEAR`
export const PROFILE_BOOKMARKS_CLEAR = `${PREFIX}_BOOKMARKS_CLEAR`

export const PROFILE_GET_ERROR = `${PREFIX}_GET_ERRORS`